
import { BaseView } from "@root/components";
import { Component } from "vue-property-decorator";
import { formData } from "./form-elements.data";
import { ProjectView } from "@/views/project-view";

@Component
export default class FormElements extends ProjectView {
    get table_inf() {
        return `
        interface {
            /// @uiLabel - Type
            /// @uiSort @uiSearch
            type: string;

            /// @uiLabel - Normal
            /// @uiAlign - lt
            normal: any;

            /// @uiLabel - Required
            /// @uiAlign - lt
            required: any;

            /// @uiLabel - Default Invalid
            /// @uiAlign - lt
            defaultInvalid: any;

            /// @uiLabel - True State
            /// @uiAlign - lt
            stateTrue: any;

            /// @uiLabel - False State
            /// @uiAlign - lt
            stateFalse: any;

            /// @uiLabel - Disabled
            /// @uiAlign - lt
            disabled: any;
        }
        `;
    }

    get formComponents() {
        return formData;
    }
}
